// Propojení produktů (doplněk WTPI) — vlastní zobrazení: Seznam / Obrázky / Velikosti
// Data plní doplněk do window.wtPIOwnDesignedProducts (configy s hasOwnDesign v pořadí z products[guid]).
// Zatím jen pro přihlášeného admina (body.admin-logged).

const myVariantsTypes = {
    list: "type-list",
    photos: "type-images",
    numbers: "type-sizes",
};

let myVariantsAvailabilitiesRequest = null;

function myVariantsMoreLabel(count) {
    if (count === 1) return "Další 1 varianta";
    if (count >= 2 && count <= 4) return "Další " + count + " varianty";
    return "Další " + count + " variant";
}

// Vyprodáno = sklad (u produktu s variantami součet variant) je 0 nebo méně
function myVariantsIsSoldOut(meta) {
    return typeof meta.stock === "number" && meta.stock <= 0;
}

function myVariantsItems(config) {
    const currentGuid = getShoptetDataLayer("product").guid;
    const metas = config.metas || {};

    return Object.keys(config.productsSetting || {}).filter(function (guid) {
        return guid === currentGuid || !metas[guid] || metas[guid].visibility === "visible";
    }).map(function (guid) {
        const setting = config.productsSetting[guid];
        const meta = metas[guid] || {};
        let image = "";

        if (config.type === "photos") {
            image = setting.isProductImageLink ? myImageSize(setting.imageLink, "detail") : setting.imageLink;
        } else if (config.type === "list" && meta.image) {
            image = myImageSize(meta.image, "related");
        }

        return {
            guid: guid,
            link: setting.link,
            label: (config.type === "numbers" ? setting.number : setting.label) || meta.name || "",
            image: image || "",
            availability: meta.availability || "",
            availabilityId: meta.availabilityId,
            isSoldOut: myVariantsIsSoldOut(meta),
            isCurrent: guid === currentGuid,
        };
    });
}

// Obsah položky (obrázek, název, dostupnost) — sdílený pro odkaz i tlačítko seznamu
function myVariantsItemContent(item, type) {
    const parts = [];
    const size = type === "list" ? 48 : 64;

    if (item.image) {
        parts.push($("<span class='myvariant-img'></span>").append(
            $("<img alt='' loading='lazy'>").attr({ src: item.image, width: size, height: size })
        )[0]);
    }

    const $text = $("<span class='myvariant-text'></span>");
    $text.append($("<span class='myvariant-name'></span>").text(item.label));

    if (type === "list" && item.availability) {
        $text.append(
            $("<span class='myvariant-availability'></span>")
                .text(item.availability)
                .attr("data-availability-id", item.availabilityId)
                .toggleClass("is-soldout", item.isSoldOut)
        );
    }

    parts.push($text[0]);
    return parts;
}

function myVariantsItemLink(item, type) {
    const $item = $("<a class='myvariant'></a>")
        .attr("href", item.link)
        .attr("data-guid", item.guid)
        .toggleClass("is-current", item.isCurrent)
        .toggleClass("is-soldout", item.isSoldOut)
        .append(myVariantsItemContent(item, type));

    if (item.isCurrent) {
        $item.attr("aria-current", "page");
    }

    if (item.isSoldOut) {
        $item.attr("title", item.availability);
    }

    return $item;
}

function myVariantsBuildList($block, items, index) {
    const current = items.filter(function (item) { return item.isCurrent; })[0] || items[0];
    const others = items.filter(function (item) { return item !== current; });
    const $frame = $("<div class='myvariants-frame'></div>");

    if (!others.length) {
        $frame.append($("<div class='myvariants-toggle is-static'></div>").append(myVariantsItemContent(current, "list")));
        return $block.append($frame);
    }

    const moreId = "myvariants-more-" + index;
    const $toggle = $("<button type='button' class='myvariants-toggle' aria-expanded='false'></button>")
        .attr("aria-controls", moreId)
        .toggleClass("is-soldout", current.isSoldOut)
        .append(myVariantsItemContent(current, "list"))
        .append($("<span class='myvariants-toggle-label'></span>").text(myVariantsMoreLabel(others.length)));

    const $more = $("<div class='myvariants-more' hidden></div>").attr("id", moreId);
    others.forEach(function (item) {
        $more.append(myVariantsItemLink(item, "list"));
    });

    return $block.append($frame.append($toggle).append($more));
}

function myVariantsBuild(config, index) {
    const items = myVariantsItems(config);
    const $block = $("<div class='myvariants " + myVariantsTypes[config.type] + "' data-wtpi></div>");

    if (config.type === "numbers") {
        $block.addClass(config.displayType === "box" ? "is-box" : "is-circle");
    }

    $block.append($("<div class='myvariants-title'></div>").text(config.title || ""));

    if (config.type === "list") {
        return myVariantsBuildList($block, items, index);
    }

    const $items = $("<div class='myvariants-items'></div>");
    items.forEach(function (item) {
        $items.append(myVariantsItemLink(item, config.type));
    });

    return $block.append($items);
}

// Barvy dostupností nejsou ve wtPIOwnDesignedProducts — bere se stejný eshopSetting.json, jaký stáhl doplněk
function myVariantsAvailabilities() {
    if (myVariantsAvailabilitiesRequest) return myVariantsAvailabilitiesRequest;

    const entry = performance.getEntriesByType("resource").filter(function (resource) {
        return resource.name.indexOf("/product-variants/") !== -1 && resource.name.indexOf("eshopSetting.json") !== -1;
    })[0];
    const settingUrl = "https://shoptet.webotvurci.cz/eshop-endpoints/" + getShoptetDataLayer("projectId") +
        "/product-variants/setting/" + getShoptetDataLayer("product").guid;
    const request = entry ? $.get(entry.name, null, null, "json") : $.get(settingUrl, null, null, "json").then(function (url) {
        return $.get(url, null, null, "json");
    });

    myVariantsAvailabilitiesRequest = request.then(function (json) {
        return (json && json.availabilities) || [];
    }, function () {
        return $.Deferred().resolve([]).promise();
    });

    return myVariantsAvailabilitiesRequest;
}

function myVariantsColorAvailabilities() {
    const $labels = $(".myvariants[data-wtpi] .myvariant-availability[data-availability-id]");
    if (!$labels.length) return;

    myVariantsAvailabilities().then(function (availabilities) {
        $labels.each(function () {
            const id = Number($(this).attr("data-availability-id"));
            const availability = availabilities.filter(function (one) { return one.id === id; })[0];

            if (availability && availability.color) {
                $(this).css("color", availability.color);
            }
        });
    });
}

function myVariantsRender() {
    const configs = window.wtPIOwnDesignedProducts;

    if (!$("body").hasClass("admin-logged") || !configs || !configs.length || $(".myvariants[data-wtpi]").length) return;

    const $anchor = $("#product-detail-form .detail-parameters, #product-detail-form .p-final-price-wrapper").first();
    if (!$anchor.length) return;

    configs.forEach(function (config, index) {
        if (!config || !myVariantsTypes[config.type] || !config.productsSetting) return;
        myVariantsBuild(config, index).insertBefore($anchor);
    });

    myVariantsColorAvailabilities();
}

if (typeof getShoptetDataLayer === "function" && getShoptetDataLayer("pageType") === "productDetail") {
    // Doplněk může doběhnout před i po ready, třída admin-logged se na body může doplnit až po ready
    document.addEventListener("wtPI:rendered", function () {
        $(myVariantsRender);
    });

    $(window).on("load", myVariantsRender);

    $(document).ready(function () {
        myVariantsRender();

        $(document).on("click", ".myvariants-toggle[aria-controls]", function () {
            const $toggle = $(this);
            const isOpen = $toggle.attr("aria-expanded") === "true";

            $toggle.attr("aria-expanded", String(!isOpen));
            $toggle.closest(".myvariants").toggleClass("is-open", !isOpen);
            $("#" + $toggle.attr("aria-controls")).prop("hidden", isOpen);
        });

        $(document).on("keydown", ".myvariants.type-list.is-open", function (e) {
            if (e.key !== "Escape") return;

            const $toggle = $(this).find(".myvariants-toggle[aria-controls]");
            $toggle.trigger("click").trigger("focus");
        });
    });
}
